<script>
import countries from "@/data/countries.json";
import { updateLocation } from "@/api/locations";
export default {
  name: "update-location-modal",
  props: ["item"],
  data() {
    return {
      show: true,
      form: {
        name: "",
        street: "",
        city: "",
        state: "",
        zip: "",
        country: "",
        id: null
      },
      countries: [],
      spinning: false
    };
  },
  mounted() {
    this.countries = countries;
  },
  computed: {
    countriesOptions() {
      return [
        { value: null, text: "Please select" },
        ...this.countries.map(list => {
          return {
            value: list.name,
            text: list.name
          };
        })
      ];
    }
  },
  watch: {
    item(newVal) {
      this.form.id = newVal ? newVal.id : null;
      this.form.name = newVal ? newVal.name : "";
      this.form.street = newVal ? newVal.street : "";
      this.form.city = newVal ? newVal.city : null;
      this.form.state = newVal ? newVal.state : null;
      this.form.zip = newVal ? newVal.zip : null;
      this.form.country = newVal ? newVal.country : null;
    }
  },
  methods: {
    async onSubmit() {
      const payload = JSON.parse(
        JSON.stringify({
          name: this.form.name,
          street: this.form.street,
          city: this.form.city,
          state: this.form.state,
          zip: this.form.zip,
          country: this.form.country
        })
      );
      // console.log("id", this.form.id);
      // console.log("payload", payload);
      this.spinning = true;
      const response = await updateLocation(this.form.id, payload);
      if (response.success) {
        this.$bvToast.toast(`Updated`, {
          title: "Locations",
          autoHideDelay: 3000,
          appendToast: false,
          variant: "info"
        });
        setTimeout(() => {
          this.spinning = false;
          this.$refs["modal-update-location"].hide();
          this.$store.dispatch("getLocations");
        }, 2000);
      }
    }
  }
};
</script>

<template>
  <b-modal
    id="modal-update-location"
    ref="modal-update-location"
    title="Update Location"
    no-close-on-esc
    no-close-on-backdrop
    centered
    hide-footer
  >
    <b-form
      v-on:submit.prevent="onSubmit"
      method="POST"
      accept-charset="UTF-8"
      enctype="multipart/form-data"
      id="mainForm"
    >
      <b-form-group
        id="input-group-name"
        label="Name:"
        label-for="input-name"
        description="Name."
      >
        <b-form-input
          id="input-name"
          v-model="form.name"
          type="text"
          required
          placeholder="Enter name"
        ></b-form-input>
      </b-form-group>
      <b-form-group
        id="input-group-street"
        label="Street:"
        label-for="input-street"
      >
        <b-form-input
          id="input-street"
          v-model="form.street"
          required
          placeholder="Enter street"
        ></b-form-input>
      </b-form-group>
      <b-row>
        <b-col>
          <b-form-group
            id="input-group-city"
            label="City:"
            label-for="input-city"
          >
            <b-form-input
              id="input-city"
              v-model="form.city"
              type="text"
              required
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group
            id="input-group-state"
            label="State:"
            label-for="input-state"
          >
            <b-form-input
              id="input-state"
              v-model="form.state"
              type="text"
              required
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group id="input-group-zip" label="Zip:" label-for="input-zip">
            <b-form-input
              id="input-zip"
              v-model="form.zip"
              type="text"
              required
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group
            id="input-group-country"
            label="Country:"
            label-for="select-template"
          >
            <b-form-select
              id="select-country"
              v-model="form.country"
              :options="countriesOptions"
              required
            ></b-form-select>
          </b-form-group>
        </b-col>
      </b-row>
      <b-button
        type="submit"
        class="float-right"
        variant="primary"
        v-if="!spinning"
      >
        Save Changes
      </b-button>
      <b-spinner
        v-show="spinning"
        label="Spinning"
        class="float-right"
      ></b-spinner>
    </b-form>
  </b-modal>
</template>
